angular.module('core')
  .service('navigationApi', [
    '$state', 'schoolApi', 'gradeApi', 'classroomApi', 'districtApi', 'studentApi', 'customerApi', 'guardianApi', 'teacherApi',
    function(
      $state, $schoolApi, $gradeApi, $classroomApi, $districtApi, $studentApi, $customerApi, $guardianApi, $teacherApi
    ) {

    var self = this;
    self.school = $schoolApi;
    self.grade = $gradeApi;
    self.guardian = $guardianApi;
    self.teacher = $teacherApi;
    self.customer = $customerApi;
    self.student = $studentApi;
    self.classroom = $classroomApi;
    self.district = $districtApi;

    /* getItem
     * loads $scope.item based on what id and type are sent in.
     * If type 'student' is passed in with id: 4 - find and return the student
     * from the student-api.js with the id of 4.
     */
    self.getItem = function(type, params, callback) {
      switch (type) {
        case 'district':
          return self.district.getDistrict(callback);

        case 'grade':
          return self.grade.getGrade(params.gradeId, callback);

        case 'school':
          return self.school.getSchool(params.schoolId, callback);

        case 'teacher':
          return self.teacher.getTeacher(params.teacherId, callback);

        case 'classroom':
          return self.classroom.getClassroom(params.classroomId, callback);

        case 'student':
          return self.student.getStudent(params.studentId, callback);

        case 'guardian':
          return self.guardian.getGuardian(params.customerId, callback);
      }
    };

    /* getList
     * Depending on what type of page you're on - based off of $state.current.name
     * get the appropriate list for that page. For instance if you're on a district
     * page you want the navigation list to show grades in that district - so in
     * the 'district' case statement - load in the list of grades.
     */
    /* jshint -W074 */ // TODO: Fix maxcomplexity violation?
    self.getList = function(type, params, isAdmin, callback) {
      var gradeIdForTeacherStudents;
      var schoolIdForTeacherStudents;
      if (isAdmin) {
        // for admins filter teacher students by grade and school
        gradeIdForTeacherStudents = params.gradeId;
        schoolIdForTeacherStudents = params.schoolId;
      }

      switch (type) {
        case 'district':
          return self.school.getSchools(callback);

        case 'grade':
          return (params.schoolId) ?
            self.teacher.getTeachersForGrade(params.schoolId, params.gradeId, callback) :
            self.school.getSchoolsForGrade(params.gradeId, callback);

        case 'school':
          if(params.gradeId) {
            return self.teacher.getTeachersForGrade(params.schoolId, params.gradeId, callback);
          }
          if(params.schoolId) {
            return self.teacher.getTeachersForSchool(params.districtId, params.schoolId, callback);
          }
          return self.teacher.getTeachers(params.teacherId, callback);

        case 'teacher':
          return self.student.getStudentsForTeacher(params.teacherId, schoolIdForTeacherStudents, gradeIdForTeacherStudents, callback);

        case 'classroom':
        case 'student':
          // don't bother making classroom students call for group
          if($state.params.classroomId && $state.params.breadcrumbs !== 'g,st') {
            return self.student.getStudentsForClassroom($state.params.classroomId, callback);
          }
          if($state.params.teacherId) {
            return self.student.getStudentsForTeacher(params.teacherId, schoolIdForTeacherStudents, gradeIdForTeacherStudents, callback);
          }
          return self.student.getStudents(callback);
        case 'guardian':
          return self.student.getStudentsForGuardian(params.customerId, callback);
      }
    };
    /* jshint +W074 */

    /* getBreadcrumbs
     * Function with side effects that immediately updates breadcrumbs as they
     * are retrieved from the APIs.
     */
    self.getBreadcrumbs = function(breadcrumbs, params) {
      var breadcrumbSubject = new Rx.Subject();

      var functionMap = {
        'grade': {
          func: self.grade.getGrade,
          params: [params.gradeId]
        },
        'school': {
          func: self.school.getSchool,
          params: [params.schoolId]
        },
        'teacher': {
          func: self.teacher.getTeacher,
          params: [params.teacherId]
        },
        'guardian': {
          func: self.guardian.getGuardian,
          params: [params.customerId]
        },
        'classroom': {
          func: self.classroom.getClassroom,
          params: [params.classroomId]
        },
        'student': {
          func: self.student.getStudent,
          params: [params.studentId]
        }
      };

      var staleBreadcrumbs = _.filter(breadcrumbs, function (breadcrumb) {
        return breadcrumb.id !== params[breadcrumb.type + 'Id'];
      });

      var updatedCount = 0;
      _.each(staleBreadcrumbs, function(breadcrumb) {
          var type = breadcrumb.type;
          var func = functionMap[type].func;
          var funcParams = functionMap[type].params;

          // success callback sets item on breadcrumb
          // TODO: what if error?
          funcParams.push(function(item) {
            if (item) {
              breadcrumb.item = item;
            }

            updatedCount++;
            if (updatedCount === staleBreadcrumbs.length) {
              breadcrumbSubject.onNext(breadcrumbs);
              breadcrumbSubject.onCompleted();
            }
          });

          // request the breadcrumb item
          func.apply(self, funcParams);
      });

      return breadcrumbSubject;
    };

  }]);
